import { PwaUpdateAction } from './pwa-update-action';

export type IrdPwaConfig = () => {
  [PwaUpdateAction.AFTER_RELOAD]: boolean;
  [PwaUpdateAction.FORCE_RELOAD]: boolean;
  [PwaUpdateAction.ASK]: boolean;
  [PwaUpdateAction.INFORM]: boolean;
} | null;

export const IRD_PWA_DEFAULT_CONFIG: IrdPwaConfig = () => ({
  [PwaUpdateAction.AFTER_RELOAD]: true,
  [PwaUpdateAction.FORCE_RELOAD]: true,
  [PwaUpdateAction.ASK]: true,
  [PwaUpdateAction.INFORM]: true,
});
